import React from "react";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
import couponGiftIcon from "@/assets/images/couponGift.png";
import VoucherCard from "@/components/Pages/Activity/Voucher/VoucherCard";
import { canShowVoucherUse, navigateVoucherUse } from "@/components/Pages/Activity/Voucher/voucherUseJump";
import styles from "./index.module.less";

const { useTranslation } = Hooks;

/**
 * 领券/送券成功弹窗（首页注册送券、voucher 兑换领券、每日未使用券提醒共用）
 */
export default function VoucherClaimModal({
  visible,
  coupon,
  onClose,
  titleId = "voucher-claim-modal-title",
  showNeverPrompt = false,
  neverPrompt = false,
  onNeverPromptChange,
}) {
  const t = useTranslation();
  const router = useRouter();

  if (!visible || !coupon) return null;

  const canUseCoupon = canShowVoucherUse(coupon, true);

  const handlePrimaryAction = () => {
    if (canUseCoupon) {
      navigateVoucherUse(coupon, { router });
    }
    onClose({ neverPrompt });
  };

  const handleOverlayClose = () => {
    onClose({ neverPrompt });
  };

  return (
    <div className={styles.overlay} role="presentation" onClick={handleOverlayClose}>
      <div
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <img className={styles.icon} src={couponGiftIcon} alt="" />
          <h2 id={titleId} className={styles.title}>
            {t("home.registerCouponModal.title")}
          </h2>
        </div>

        <div className={styles.cardSlot}>
          <VoucherCard item={coupon} t={t} layout="modal" showAicopyUse={false} />
        </div>

        {showNeverPrompt ? (
          <label className={styles.neverPrompt}>
            <span className={styles.neverPromptCheckboxWrap}>
              <input
                type="checkbox"
                className={styles.neverPromptInput}
                checked={neverPrompt}
                onChange={(e) => onNeverPromptChange?.(e.target.checked)}
              />
              <span className={styles.neverPromptCheckboxVisual} aria-hidden />
            </span>
            <span className={styles.neverPromptText}>
              {t("home.unusedCouponModal.neverShow") || "Don't show again"}
            </span>
          </label>
        ) : null}

        <button type="button" className={styles.okBtn} onClick={handlePrimaryAction}>
          {t("activity.voucherUseAicopy") || "Use"}
        </button>
      </div>
    </div>
  );
}
